import React from 'react';
import { BaseLayoutFactory } from '../global/base-layout-factory';
import { AuditDetailProvider } from './context/audit-detail-context';
import { AuditDetailComponent } from './audit-detail-component';

export function AuditDetailFactory() {
  return (
    <BaseLayoutFactory>
      <AuditDetailProvider>
        <AuditDetailComponent />
      </AuditDetailProvider>
    </BaseLayoutFactory>
  );
}
